export class UtmParams {
    constructor(defaultParams = {}, additionalLinks = []) {
        this.defaultParams = defaultParams
        this.additionalLinks = additionalLinks
        this.utmNames = ['source', 'medium', 'campaign', 'term', 'content']
        this.params = typeof URLSearchParams !== 'undefined' ?
            new URLSearchParams(window.location.search) : ''
        this.paramsStr = ''
        this.fxRegex = /^https?:\/\/(fx|go)(web)?(\.|-[a-z]{3,}\.)([a-z]{3,9})\.([a-z]{2,})(\.pl)?/
    }

    get() {
        this.utmNames.forEach(name => {
            if (!this.params.get(`utm_${name}`) && this.defaultParams[name]) {
                this.params.set(`utm_${name}`, this.defaultParams[name])
            }
        })
        this.params.forEach((value, key) => {
            const utmName = key.includes('utm') ? key.slice(key.indexOf('_') + 1) : ''
            if (this.utmNames.includes(utmName)) {
                this.paramsStr = this.paramsStr + '&' + key + '=' + value
            }
        })
        return this.paramsStr
    }

    set() {
        if (!this.get().length) {
            return
        }

        [...document.querySelectorAll('a')].forEach(link => {
            let { href } = link
            const isAdditionalLink = this.additionalLinks.filter(link => href.includes(link) && !href.includes('mailto'))
            if (this.fxRegex.test(href) || isAdditionalLink.length) {
                href += href.includes('?') ? this.paramsStr : this.paramsStr.replace('&', '?')
                link.href = href
            }
        })
    }
}
